var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-cell"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"value van-ellipsis"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }